module.exports = __webpack_public_path__ + "img/defaultProfileImage.6b332e2a.svg";